import $ from 'jquery';
import { debounce } from 'lodash';

export default class Accordion {
    constructor(element, onToggleHandler) {
        this.$accordion = $(element);
        this.$items = this.$accordion.children('[data-accordion-item]');
        this.$triggers = this.$items.children('[data-accordion-item-trigger]');
        this.onToggleHandler = onToggleHandler;

        this.calculateHeights();

        // Toggle accordion items on trigger click
        this.$triggers.on('click', (e) => this.onTriggerClick(e.delegateTarget));

        // React to child element height changes (e.g. nested accordions)
        this.$accordion.on('uiAccordionChildItemCollapsed', this.handleChildItemCollapse.bind(this));

        // Re-calculate heights when browser size changes
        $(window).on('resize', debounce(this.calculateHeights.bind(this), 300));
    }

    onTriggerClick(triggerEl) {
        this.toggle(triggerEl);
        this.onToggleHandler(triggerEl);
    }

    deactivateItem(itemEl) {
        const triggerEl = itemEl.querySelector('[data-accordion-item-trigger]');

        this.toggle(triggerEl);
    }

    toggle(triggerEl) {
        const $body = $(triggerEl).siblings('[data-accordion-item-body]');
        const $item = $(triggerEl).closest('[data-accordion-item]');
        const bodyHeight = $body.data('height');
        const $wrapperAccordion = this.$accordion.parent().closest('[data-accordion]');

        if ($item.attr('data-active') !== 'true') {
            $body.css({
                minHeight: bodyHeight,
            });

            $item.attr('data-active', true);

            // Move to min-height after transition to react to child element
            // height changes
            setTimeout(() => {
                if ($item.attr('data-active') === 'true') {
                    $body.css({
                        height: 'auto',
                        minHeight: bodyHeight,
                    });
                }
            }, 500);
        } else {
            $body.data('height', $body.innerHeight());

            $body.css({
                height: 0,
                minHeight: 0,
            });

            $item.removeAttr('data-active');
            $wrapperAccordion.trigger('uiAccordionChildItemCollapsed');
        }
    }

    calculateHeights() {
        this.$items.children('[data-accordion-item-body]').each((idx, el) => {
            const $el = $(el);
            const isActive = $el.closest('[data-accordion-item]').attr('data-active') === 'true';

            // Prepare element for height calculation
            $el.css({
                height: 'auto',
                visibility: 'visible',
            });

            // Set original-height only if not set for later re-use
            if (!$el.data('oiginal-height')) {
                $el.data('oiginal-height', $el.innerHeight());
            }

            // Update height to store updated height
            $el.data('height', $el.innerHeight());

            // Reset element after height calculation
            if (isActive) {
                $el.css({
                    height: 'auto',
                    visibility: '',
                    minHeight: $el.innerHeight(),
                });
            } else {
                $el.css({
                    height: 0,
                    visibility: '',
                });
            }
        });
    }

    handleChildItemCollapse() {
        this.$items.children('[data-accordion-item-body]').each((idx, el) => {
            const $el = $(el);

            $el.css({
                height: 'auto',
                minHeight: $(el).data('oiginal-height') || $el.data('height'),
            });
        });
    }

    static create(selector = '[data-accordion]', onToggleHandler = () => {}) {
        const accordions = document.querySelectorAll(selector);
        for (const accordion of accordions) {
            new Accordion(accordion, onToggleHandler);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./js/marketing/components/Accordion.js
 **/